export const defaultConfig = {
  columns: [],
  filters: [],
  order: {},
  selectedRows: []
}

export default defaultConfig



// WEBPACK FOOTER //
// ./src/modules/Framework/Grid/Helpers/defaultConfig.js